import React from 'react'
import { Col, Row, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <div className="container-fluid footer-container " >
      <Container className="footer-container-one" >
        <Row xl={12} >
          <Col xl={3} lg={3} md={4} sm={5} xs={5} >
            <img className="footer-image" src="/images/logo/logo.jpg" alt='Loading'/>
          </Col>
          <Col xl={3} lg={3} md={4} sm={7} xs={7} >
            <ul className="footer-link" >
              <h3 className="footer-quick-link" >Quick Links</h3>
              <li className="footer-link-a"> <Link to="/about">About Us</Link> </li>
              <li className="footer-link-a"> <Link to="/services"> Services </Link> </li>
              <li className="footer-link-a">  <Link to="/blogs"> Blogs</Link> </li>
            </ul>
          </Col>
          <Col className="footer-col-3" xl={3} lg={3} md={4} sm={7} xs={7} >
            <ul className="footer-link">
              <h3 className="footer-quick-link">Contact Us</h3>
              <li> Dr Bupathi's Gastro, </li>
              <li> ChaitanyaPuri, Hyderabad </li>
              <li>Phone: +918039652916 </li>
              <li>rajbupathi.dr@gmail.com </li>
            </ul>
          </Col>
          <Col className="footer-col-4" xl={3} lg={3} md={4} sm={5} xs={5} >
            <h3 className="footer-quick-link">Follow Us</h3>
            <div className="footer-icon-div" >
              <a href="https://www.facebook.com/rajbhupathi.dr" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="/images/icons/facebook.png" alt='Loading'/> </a>
              <a href="https://www.instagram.com/drbhupathirajendraclinic/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="/images/icons/instagram.png" alt='Loading' /> </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="/images/icons/youtube.png" alt='Loading'/> </a>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-center footer_copyright" >
            <span> ©2022 Copyrights Bupathi Gastro & Laparoscopic Center </span>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
